module.exports = __webpack_public_path__ + "media/slider/Banner-3-4270fa3c.jpg";